var ComponentManager = /** @class */ (function () {
    function ComponentManager(showLeagueInEventCard, outrightSelectionsCount, shouldShowOutrightSubheading, deviceDetect, componentManagerConstants) {
        this.showLeagueInEventCard = showLeagueInEventCard;
        this.outrightSelectionsCount = outrightSelectionsCount;
        this.shouldShowOutrightSubheading = shouldShowOutrightSubheading;
        this.deviceDetect = deviceDetect;
        this.constants = componentManagerConstants;
    }
    ComponentManager.prototype.getSubheadingHeight = function () {
        return this.deviceDetect.isDesktop
            ? this.constants.heights.Subheading.desktop + this.constants.offsets.Subheading.desktop // 38 + 2 = 40
            : this.constants.heights.Subheading.mobile + this.constants.offsets.Subheading.mobile; // 48 + 1 = 49
    };
    ComponentManager.prototype.getComponentHeight = function (event, markets) {
        return this["measure" + event.componentType](event, markets);
    };
    ComponentManager.prototype.getAmericanSelectionsMaxCount = function (markets) {
        return markets && markets.some(function (m) { return m.selections.length > 2; }) ? 3 : 2;
    };
    ComponentManager.prototype.measureAggregateCard = function (event) {
        // Desktop version same as Mobile
        return this.constants.heights.AggregateCard.desktop + this.constants.offsets.AggregateCard.desktop; // 73 + 4 = 77
    };
    ComponentManager.prototype.measureCardTypes = function (event, markets) {
        return event.cardType
            ? this["measure" + event.cardType](event, markets)
            : 0;
    };
    ComponentManager.prototype.measureAmerican = function (event, markets) {
        var selectionsCount = this.getAmericanSelectionsMaxCount(markets);
        return this.deviceDetect.isDesktop
            ? this.setAmericanCardHeightDesktop(selectionsCount)
            : this.setAmericanCardHeightMobile(selectionsCount);
    };
    ComponentManager.prototype.measureMultiview = function (event) {
        // WARNING: Make sure that you see RegularCard on Mobile, instead of MultiviewCard
        if (!this.deviceDetect.isDesktop) {
            return this.showLeagueInEventCard
                ? this.constants.heights.DefaultCard.mobile + this.constants.heights.LeagueInEventCard.mobile + this.constants.offsets.DefaultCard.mobile // 84 + 20 + 1 = 105
                : this.constants.heights.DefaultCard.mobile + this.constants.offsets.DefaultCard.mobile; // 84 + 1 = 85
        }
        return this.showLeagueInEventCard
            ? this.constants.heights.DefaultCard.desktop + this.constants.heights.LeagueInEventCard.desktop + this.constants.offsets.DefaultCard.desktop // 60 + 20 + 2 = 82
            : this.constants.heights.DefaultCard.desktop + this.constants.offsets.DefaultCard.desktop; // 60 + 2 = 62
    };
    ComponentManager.prototype.measureRegular = function (event) {
        if (this.deviceDetect.isDesktop) {
            return this.showLeagueInEventCard
                ? this.constants.heights.DefaultCard.desktop + this.constants.heights.LeagueInEventCard.desktop + this.constants.offsets.DefaultCard.desktop // 84 + 20 + 1 = 105
                : this.constants.heights.DefaultCard.desktop + this.constants.offsets.DefaultCard.desktop; // 84 + 1 = 85
        }
        return this.showLeagueInEventCard
            ? this.constants.heights.DefaultCard.mobile + this.constants.heights.LeagueInEventCard.mobile + this.constants.offsets.DefaultCard.mobile // 60 + 20 + 2 = 82
            : this.constants.heights.DefaultCard.mobile + this.constants.offsets.DefaultCard.mobile; // 60 + 2 = 62
    };
    ComponentManager.prototype.measureAsian = function (event) {
        return this.measureRegular(event);
    };
    ComponentManager.prototype.measureMiniCardTypes = function () {
        return this.constants.heights.DefaultMiniCard.desktop + this.constants.offsets.DefaultMiniCard.desktop; // 56 + 2 = 58;
    };
    ComponentManager.prototype.measureMiniOutright = function () {
        return this.constants.heights.MiniOutright.desktop + this.constants.offsets.DefaultMiniCard.desktop; // 36 + 2 = 38;
    };
    ComponentManager.prototype.measureLiveOutright = function () {
        return !this.deviceDetect.isMobile
            ? this.constants.heights.LiveOutright.desktop + this.constants.offsets.LiveOutright.desktop // 54 + 2 = 56
            : this.constants.heights.LiveOutright.mobile + this.constants.offsets.LiveOutright.mobile; // 66 + 1 = 67
    };
    ComponentManager.prototype.measurePreLiveOutright = function (event, markets) {
        var selectionsCount = markets[0].selections.length;
        var selectionsToShow = Math.min(selectionsCount, this.outrightSelectionsCount);
        var showViewAll = selectionsCount > this.outrightSelectionsCount;
        var selectionHeight = this.setPreLiveOutrightHeight(selectionsToShow, this.deviceDetect.isDesktop);
        var subheadingHeight = this.shouldShowOutrightSubheading
            ? this.getSubheadingHeight()
            : 0;
        var viewAllBtnHeight = showViewAll
            ? this.setViewAllPreliveOutrightHeight(this.deviceDetect.isDesktop)
            : 0;
        return selectionHeight + subheadingHeight + viewAllBtnHeight;
    };
    ComponentManager.prototype.getOffsetValue = function (event) {
        if (this["getOffsetValue" + event.componentType]) {
            return this["getOffsetValue" + event.componentType]();
        }
        return this.deviceDetect.isDesktop
            ? this.constants.offsets.DefaultCard.desktop // 2
            : this.constants.offsets.DefaultCard.mobile; // 2
    };
    ComponentManager.prototype.getOffsetValueAggregateCard = function () {
        return this.constants.offsets.AggregateCard.desktop; // 4
    };
    ComponentManager.prototype.getOffsetValuePreLiveOutright = function () {
        return 0;
    };
    ComponentManager.prototype.setAmericanCardHeightDesktop = function (selectionsCount) {
        var buttonsHeight = selectionsCount > 2
            ? 3 * this.constants.heights.ButtonInAmericanCard.desktop
            : 2 * this.constants.heights.ButtonInAmericanCard.desktop;
        var leagueHeight = this.showLeagueInEventCard
            ? this.constants.heights.ButtonInAmericanCard.desktop
            : 0;
        // 88 for 3 button rows, 62 for 2 button rows
        var height = this.constants.heights.AmericanCard.desktop
            + buttonsHeight
            - this.constants.offsets.ButtonInAmericanCard.desktop
            + this.constants.offsets.DefaultCard.desktop;
        return selectionsCount > 2
            ? height
            : height + leagueHeight;
    };
    ComponentManager.prototype.setAmericanCardHeightMobile = function (selectionsCount) {
        var buttonsHeight = selectionsCount > 2
            ? 3 * this.constants.heights.ButtonInAmericanCard.mobile
            : 2 * this.constants.heights.ButtonInAmericanCard.mobile;
        var leagueHeight = this.showLeagueInEventCard
            ? this.constants.heights.LeagueInEventCard.mobile
            : 0;
        // 243 or 223 for 3 button rows, 207 or 187 for 2 button rows
        return this.constants.heights.AmericanCard.mobile
            + buttonsHeight
            - this.constants.offsets.ButtonInAmericanCard.mobile
            + leagueHeight
            + this.constants.offsets.DefaultCard.mobile;
    };
    ComponentManager.prototype.setPreLiveOutrightHeight = function (selectionsCount, isDesktop) {
        return isDesktop
            ? this.setPreLiveOutrightHeightDesktop(selectionsCount)
            : this.setPreLiveOutrightHeightMobile(selectionsCount);
    };
    ComponentManager.prototype.setViewAllPreliveOutrightHeight = function (isDesktop) {
        return isDesktop
            ? this.constants.heights.ViewAllButtonContainer.desktop // 55
            : this.constants.heights.ViewAllButtonContainer.mobile; // 70
    };
    ComponentManager.prototype.setPreLiveOutrightHeightDesktop = function (selectionsCount) {
        return Math.ceil(selectionsCount / 2) * this.constants.heights.PreLiveOutright.desktop // 49
            + 2 * this.constants.offsets.PreLiveOutrightContainer.desktop; // 2 * 2 = 4
    };
    ComponentManager.prototype.setPreLiveOutrightHeightMobile = function (selectionsCount) {
        return selectionsCount * this.constants.heights.PreLiveOutright.mobile // 48
            + 2 * this.constants.offsets.PreLiveOutrightContainer.mobile; // 2 * 2 = 4
    };
    return ComponentManager;
}());
export { ComponentManager };
//# sourceMappingURL=ComponentManager.js.map